<template>
	<div class="">
			<el-breadcrumb separator-class="el-icon-arrow-right" class="m-b-20">
				<el-breadcrumb-item class="color_A6A6A6"><span class="com_pointer" @click="$router.push('/pass')">知识宝典</span></el-breadcrumb-item>
				<el-breadcrumb-item>{{ categoryName }}</el-breadcrumb-item>
			</el-breadcrumb>

			<!-- PC端列表式展示 -->
			<div class="paper-table-wrap" v-loading="loading">
				<div v-for="group in groupedPapers" :key="group.key" class="paper-type-section">
					<div class="paper-type-title">
						<span>{{ categoryName }} - {{ group.name }}</span>
						<el-tag size="mini" type="info">{{ group.items.length }} 组练习</el-tag>
					</div>
					<el-table :data="group.items" style="width: 100%" stripe
						:header-cell-style="{background:'#f5f7fa',color:'#333',fontWeight:'bold'}">
						<el-table-column label="练习名称" min-width="200">
							<template slot-scope="scope">
								<span class="font_weight">{{ scope.row.display_name }}</span>
								<span class="color_999 font_s12" v-if="scope.row.remark" style="margin-left:8px;">{{ scope.row.remark }}</span>
							</template>
						</el-table-column>
						<el-table-column label="题目数" width="90" align="center">
							<template slot-scope="scope">
								{{ scope.row.type_question_count || 0 }}题
							</template>
						</el-table-column>
						<el-table-column label="时间限制" width="100" align="center">
							<template slot-scope="scope">
								{{ scope.row.time_limit > 0 ? scope.row.time_limit + '分钟' : '不限时' }}
							</template>
						</el-table-column>
						<el-table-column label="满分" width="80" align="center">
							<template slot-scope="scope">
								{{ scope.row.type_total_score || 100 }}分
							</template>
						</el-table-column>
						<el-table-column label="类型" width="80" align="center">
							<template slot-scope="scope">
								<el-tag :type="scope.row.is_free == 1 ? 'success' : 'warning'" size="mini">
									{{ scope.row.is_free == 1 ? '免费' : '付费' }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="120" align="center">
							<template slot-scope="scope">
								<el-button type="primary" size="mini" @click="startExam(scope.row)"
									style="background-color: #163F88; border-color: #163F88;">
									开始答题
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<!-- 移动端卡片式展示 -->
			<div class="paper-cards-mobile" v-loading="loading">
				<div v-for="group in groupedPapers" :key="group.key" class="paper-type-section-m">
					<div class="paper-type-title-m">{{ categoryName }} - {{ group.name }}</div>
					<div class="paper-card-m" v-for="item in group.items" :key="item.paper_type_key">
						<div class="paper-card-m-header">
							<span class="paper-card-m-name">{{ item.display_name }}</span>
							<el-tag :type="item.is_free == 1 ? 'success' : 'warning'" size="mini">
								{{ item.is_free == 1 ? '免费' : '付费' }}
							</el-tag>
						</div>
						<div class="paper-card-m-info">
							<span>{{ item.type_question_count || 0 }}题</span>
							<span>{{ item.time_limit > 0 ? item.time_limit + '分钟' : '不限时' }}</span>
							<span>满分{{ item.type_total_score || 100 }}</span>
						</div>
						<div class="paper-card-m-action">
							<el-button type="primary" size="small" @click="startExam(item)"
								style="background-color: #163F88; border-color: #163F88; width: 100%;">
								开始答题
							</el-button>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!loading && groupedPapers.length === 0" class="text_c p-30">
				<i class="el-icon-document" style="font-size: 60px; color: #ccc;"></i>
				<p class="color_999 m-t-10">该分类下暂无试卷</p>
			</div>
	</div>
</template>
<script>
export default {
	name: "PassPapers",
	data() {
		return {
			loading: false,
			categoryName: '',
			categoryId: '',
			paperList: [],
		};
	},
	computed: {
		groupedPapers() {
			const typeMeta = [
				{ key: 'judge', name: '判断题' },
				{ key: 'single', name: '单选题' },
				{ key: 'multi', name: '多选题' },
			];
			const groups = typeMeta.map(meta => ({ ...meta, items: [] }));
			this.paperList.forEach(paper => {
				const typeGroups = Array.isArray(paper.question_type_groups) && paper.question_type_groups.length
					? paper.question_type_groups
					: [{ key: '', name: '综合题', question_count: paper.question_count, total_score: paper.total_score }];
				typeGroups.forEach(type => {
					const key = type.key || 'mixed';
					let group = groups.find(item => item.key === key);
					if (!group) {
						group = { key, name: type.name || '综合题', items: [] };
						groups.push(group);
					}
					group.items.push({
						...paper,
						question_type: type.key || '',
						question_type_name: type.name || '综合题',
						type_question_count: type.question_count || paper.question_count || 0,
						type_total_score: type.total_score || paper.total_score || 0,
						display_name: `${paper.name} - ${type.name || '综合题'}`,
						paper_type_key: `${paper.id}_${key}`,
					});
				});
			});
			return groups.filter(group => group.items.length > 0);
		}
	},
	activated() {
		this.categoryId = this.$route.query.category_id || '';
		this.categoryName = this.$route.query.category_name || '试卷列表';
		this.getPaperList();
	},
	methods: {
		getPaperList() {
			this.loading = true;
			this.$api.pass.getPaperList({ category_id: this.categoryId }).then((res) => {
				if (res.code == 1) {
						this.paperList = (res.data && res.data.data) || [];
				}
			}).catch(() => {}).finally(() => {
				this.loading = false;
			});
		},
		startExam(item) {
			if (!localStorage.getItem('u_token')) {
				this.$message.info('请先登录！');
				this.$router.push('/login');
				return;
			}
			if (item.is_free != 1) {
				// 检查是否有权限
				this.$api.authPass.checkAccess().then((res) => {
					if (res.code == 1 && res.data && res.data.has_access) {
						this.$router.push({ path: '/pass/exam', query: { paper_id: item.id, paper_title: item.display_name || item.name, question_type: item.question_type || '' } });
					} else {
						this.$confirm('该试卷需要购买套餐后才能答题，是否前往购买？', '提示', {
							confirmButtonText: '去购买',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$router.push({ path: '/center', query: { tab: 'passPackages' } });
						}).catch(() => {});
					}
				}).catch(() => {
					this.$message.error('检查权限失败，请稍后重试');
				});
			} else {
				this.$router.push({ path: '/pass/exam', query: { paper_id: item.id, paper_title: item.display_name || item.name, question_type: item.question_type || '' } });
			}
		}
	}
};
</script>
<style scoped>
.paper-table-wrap {
	background: #fff;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.paper-type-section + .paper-type-section {
	border-top: 12px solid #f4f7fb;
}
.paper-type-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 20px;
	font-size: 16px;
	font-weight: bold;
	color: #163F88;
	background: #f8fbff;
}
.paper-cards-mobile {
	display: none;
}
@media screen and (max-width: 768px) {
	.paper-table-wrap {
		display: none;
	}
	.paper-cards-mobile {
		display: block;
	}
	.paper-type-section-m {
		margin-bottom: 16px;
	}
	.paper-type-title-m {
		font-size: 15px;
		font-weight: bold;
		color: #163F88;
		margin: 4px 0 10px;
	}
	.paper-card-m {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		margin-bottom: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	}
	.paper-card-m-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	.paper-card-m-name {
		font-weight: bold;
		font-size: 14px;
		flex: 1;
		margin-right: 8px;
	}
	.paper-card-m-info {
		font-size: 12px;
		color: #999;
		margin-bottom: 12px;
		display: flex;
		gap: 15px;
	}
	.paper-card-m-action {
		text-align: center;
	}
}
</style>
